import CoreFrameNavigationViewViewModel from "@/Components/CoreFrameNavigation/CoreFrameNavigationViewViewModel";
import CoreFrameNavigationView from "@/Components/CoreFrameNavigation/CoreFrameNavigationView";
import ComponentManager from "@/Management/ComponentManager";
import ViewFactory from "@/Factories/ViewFactory";

export default class CoreFrameNavigationViewFactory extends ViewFactory {
    public viewModel: CoreFrameNavigationViewViewModel;
    public view: CoreFrameNavigationView;

    private NavigationViewModel = ComponentManager.getViewModel<typeof CoreFrameNavigationViewViewModel>('NavigationViewModel');
    private NavigationView = ComponentManager.getView<typeof CoreFrameNavigationView>('NavigationView');

    constructor(params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Navigation';
    }

    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.NavigationViewModel({ viewFactory: this, locator: 'navigation' });
        }
        if (this.view == null) {
            this.view = new this.NavigationView(this.viewModel, this.createRootElement('CoreFrameNavigation'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('Navigation', CoreFrameNavigationViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');